import "./SocialIcons.css";

const SocialIcons = () => {
  return (
    <div className="sticky-container">
      <ul className="social-icons">
        <li>
          <a
            href="https://www.facebook.com/rennamobileoman"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f fa-lg white"></i>
          </a>
        </li>
        <li>
          <a
            href="https://instagram.com/rennamobileoman"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram fa-lg white"></i>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialIcons;
